import 'bootstrap/js/dist/modal'
import i18n from 'i18n'
import Session from 'javascripts/layouts/v2/Session'
import React, { useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter } from 'react-router'
import { appTheme } from 'spa/config/styled'
import { ThemeProvider } from 'styled-components'
import { SessionContext } from '../profile_sheets/information_disclosures/application'

import JobOfferContentView from './JobOfferContentView'
import JobOfferSideNav from './JobOfferSideNav'
import { fetchSessionOnce } from './fetchSessionOnce'
import './show'

window.addEventListener('DOMContentLoaded', () => {

  if (!document.querySelector('body.controller--job_offers')) return false

  const sideNav = document.querySelector('[data-react-job-offer-side-nav]')
  if (sideNav) {
    const root = createRoot(sideNav)
    root.render(<JobOfferSideNavForSlim />)
  }

  const contentView = document.querySelector('[data-react-job-offer-content-view]')
  if (contentView) {
    const props = JSON.parse(contentView.dataset.reactJobOfferContentView)
    const root = createRoot(contentView)
    root.render(<JobOfferContentViewForSlim {...props} />)
  }
})

const JobOfferSideNavForSlim: React.FC = () => {
  const [session, setSession] = React.useState<Session>(null)
  useEffect(() => {
    void fetchSessionOnce()
      .then((json: Session) => setSession(json))
      .catch((error) => {
        console.error('Failed to fetch session for JobOfferSideNav', error)
      })
  }, [])
  return (
    <SessionContext.Provider value={session}>
      <JobOfferSideNav />
    </SessionContext.Provider>
  )
}

const JobOfferContentViewForSlim: React.FC = (props) => {
  const [session, setSession] = React.useState<Session>(null)
  useEffect(() => {
    void fetchSessionOnce()
      .then((json: Session) => setSession(json))
      .catch((error) => {
        // セッション取得失敗時は null のまま描画を継続する
        console.error('Failed to fetch session for JobOfferContentView', error)
      })
  }, [])
  return (
    <I18nextProvider i18n={ i18n }>
      <SessionContext.Provider value={session}>
        <BrowserRouter>
          <ThemeProvider theme={appTheme}>
            <JobOfferContentView {...props} />
          </ThemeProvider>
        </BrowserRouter>
      </SessionContext.Provider>
    </I18nextProvider>
  )
}
